import { MONTH_ORDER } from '@exam-center/exam-distribution-management';
import { Navigate, useParams } from '@exam-center/router';
import { dayjs } from '@shared/utils';

export default function ExamDistributionMonthPage() {
  const { year: currentYear } = useParams('/:examCenterCode/exam-events/years/:year');
  const currentMonth = MONTH_ORDER[dayjs().month()];

  return (
    <Navigate
      to='/admin/exam-distribution/year/:year/month/:month/exam-assigning'
      params={{ year: currentYear.toString(), month: currentMonth.toString() }}
      replace
    />
  );
}
